




































































import { UiButton, UiIconButton, UiTextbox } from '../keen-ui';

import { DeviceEnum } from '../../enums';

export default {
  name: 'actions-bar',
  components: {
    UiTextbox,
    UiButton,
    UiIconButton
  },
  computed: {
    deleteActionDisabled: function (): boolean {
      return (!this.selection.length ||
        (this.forceOnlyOneItemEnabled && this.selection.some((selectedItem: any) => selectedItem.enabled)));
    },
    enableActionDisabled: function (): boolean {
      return ((this.forceOnlyOneItemEnabled && (this.selection.length > 1)) ||
        this.selection.every((selectedItem: any) => selectedItem.enabled));
    },
    disableActionDisabled: function (): boolean {
      return this.selection.every((selectedItem: any) => !selectedItem.enabled);
    },
    enableActionAllowed: function (): boolean {
      return !!this.permissions.update && this.enableActionsAvailable;
    }
  },
  data: function () {
    return {
      DeviceEnum,
      createButtonConfig: {
        color: 'primary',
        icon: 'add'
      },
      iconButtonConfig: {
        color: 'primary'
      }
    };
  },
  methods: {
    onQueryChange: function (): void {
      const inputEl: HTMLInputElement = (this.$refs.searchbox.$refs.input as HTMLInputElement);
      this.$emit('queryChange', inputEl.value);
    }
  },
  props: {
    searchBoxAvailable: Boolean,
    query: String,
    selection: Array,
    permissions: Object,
    enableActionsAvailable: Boolean,
    forceOnlyOneItemEnabled: Boolean,
    forceOnlyOneItemEditable: Boolean
  }
};

